import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { ListContent } from "./QuoteSpecificCondition.styled";

const ParametersFormat = (props) => {
  const { t, parametersFormat, parametersValue } = props;

  const fetchInfo = () => {
    let patterInfo = "";
    if (parametersFormat !== "" && parametersValue !== "") {
      const patternData = JSON.parse(parametersFormat);
      const patternValue = JSON.parse(parametersValue);

      const patternKey = Object.keys(patternValue);
      const patternKeyValue = Object.values(patternValue);

      Object.keys(patternData).forEach((key) => {
        if (key === "pattern") {
          patterInfo = patternData[key];
        }
      });

      patternKey.map((pattern, key) => {
        const val = patternKeyValue[key];
        patterInfo = patterInfo.replace("%" + pattern + "%", val);
      });
    }
    return patterInfo;
  };

  return (
    <>
      <ListContent>{fetchInfo()}</ListContent>
    </>
  );
};

ParametersFormat.propTypes = {
  t: PropTypes.func.isRequired,
  parametersFormat: PropTypes.string.isRequired,
  parametersValue: PropTypes.string.isRequired,
};

export default withTranslation()(ParametersFormat);
